import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { FrameModel } from "../model/Frame";

type FrameStore = {
  frame?: FrameModel;
  setFrame: (frame: FrameModel) => void;
};

const useFrameStore = create<FrameStore>()(
  persist(
    (set) => ({
      frame: undefined,
      setFrame: (frame: FrameModel) => set({ frame }),
    }),
    { name: "frame-store" }
  )
);

export { useFrameStore };
